const KEYCLOAK_REALM = "Internal";
const KEYCLOAK_AUTHORITY = `https://auth.intusystems.info/auth/realms/${KEYCLOAK_REALM}`;
export const KEYCLOAK_TOKEN_URL = `${KEYCLOAK_AUTHORITY}/protocol/openid-connect/token`;
export const KEYCLOAK_LOGOUT_URL = `${KEYCLOAK_AUTHORITY}/protocol/openid-connect/logout`;

export const keycloakConfig = {
  authority: KEYCLOAK_AUTHORITY,
  client_id: "operations",
  // Replace with actual client secret if required for backend/confidential client use.
  client_secret: "omeDvcR9rMRwI7AQdix6OUw4gXE27llE",
  redirect_uri: window.location.origin + "/login",
  post_logout_redirect_uri: window.location.origin + "/login",
  scope: "openid profile email",
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};

export const getPostLogoutRedirectUri = () =>
  keycloakConfig.post_logout_redirect_uri;

/** Build Keycloak RP-initiated logout URL (ends SSO session in Keycloak). */
export function buildKeycloakLogoutUrl(idToken) {
  const params = new URLSearchParams();
  params.set("client_id", keycloakConfig.client_id);
  params.set("post_logout_redirect_uri", getPostLogoutRedirectUri());
  if (idToken) {
    params.set("id_token_hint", idToken);
  }
  return `${KEYCLOAK_LOGOUT_URL}?${params.toString()}`;
}

export const oidcConfig = {
  authority: keycloakConfig.authority,
  client_id: keycloakConfig.client_id,
  redirect_uri: keycloakConfig.redirect_uri,
  post_logout_redirect_uri: keycloakConfig.post_logout_redirect_uri,
  scope: keycloakConfig.scope,
  onSigninCallback: keycloakConfig.onSigninCallback,
  // Token refresh is handled by keycloakTokenService (single leader tab).
  // Leaving this on makes every open tab hit the token endpoint on its own.
  automaticSilentRenew: false,
  monitorSession: false,
};
